import useWSWithTopic from '../../hooks/useWSWithTopic';
import { stores } from '../../stores';

function WSShipmentModifier() {
    useWSWithTopic("shipment-modifier_general", data => stores.deliveryStore.handleShipmentModifier(data));
    
    return null;
}

export default WSShipmentModifier;